import { render } from "./FixedNav.vue?vue&type=template&id=2fba590a&scoped=true&ts=true"
import script from "./FixedNav.vue?vue&type=script&lang=ts"
export * from "./FixedNav.vue?vue&type=script&lang=ts"

import "@/components/FixedNav/style.scss?vue&type=style&index=0&id=2fba590a&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fba590a"]])

export default __exports__